import { actions } from '../../utils/constants';

const INITIAL_STATE = {
    userInfo: { photoUrl: null },
    externalLogin: false,
};

export default (state = INITIAL_STATE, { type, payload } ) => {
    switch (type) {

        case actions.USER_INFO_FETCHED:
            return { ...state, userInfo: payload };
        case actions.SET_EXTERNAL_LOGIN:
            return { ...state, externalLogin: payload };
        default:
            return state;
    }
};

export const externalLogin = (code) => ({
    type: actions.EXTERNAL_LOGIN,
    payload: code,
});



// WEBPACK FOOTER //
// ./src/components/login/login.reducer.js